import { EntDirectoryInfoName } from "../directoryInfoName";
import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";

export class EntWinterCerealFertilizer {
  id: number | null = null;
  periodStart: string | null = null;
  periodEnd: string | null = null;
  territorialUnit: EntTerritorialsUnits | null = null;
  winterCerealFertilizerDetails: WinterCerealFertilizerDetails[] | null = null;

  territorialUnitId?: number | null = null;
  cropTypeId?: number | null = null;
}

export class WinterCerealFertilizerDetails {
  key: number | null = null;
  id: number | null = null;
  territorialUnitDistrictId: number | null = null;
  territorialUnitDistrict?: EntTerritorialsUnits | null = null;
  neededPKg: number | null = null;
  neededKKg: number | null = null;
  totalNeededKg?: number | null = null;
  factSownArea: number | null = null;
  fertilizedArea: number | null = null;
  fertilizationPercent?: number | null = null;
  totalSownArea: number | null = null;
  deliveredPKg?: number | null = null;
  deliveredKKg?: number | null = null;
  availabilityPK?: number | null = null;
  totalDelivered?: number | null = null;

}